(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const shell = document.querySelector('[data-cart-drawer-shell]');
    if (!shell) return;
    const drawer = shell.querySelector('.cart-drawer');
    const body = shell.querySelector('[data-cart-body]');
    const footer = shell.querySelector('[data-cart-footer]');
    const status = shell.querySelector('[data-cart-status]');
    let lastFocus = null;
    let noteTimer;
    const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    const formatMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    const open = () => {
      lastFocus = document.activeElement;
      shell.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      shell.querySelector('[data-cart-close]:not(.cart-drawer__overlay)')?.focus();
    };
    const close = () => {
      shell.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lastFocus?.focus();
    };
    const render = (cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
      if (!document.querySelector('[data-cart-count]') && cart.item_count > 0) {
        const icon = document.querySelector('.header__cart-icon');
        if (icon) icon.insertAdjacentHTML('beforeend', `<span class="header__cart-count" data-cart-count>${cart.item_count}</span>`);
      }
      if (!cart.item_count) {
        body.innerHTML = `<div class="cart-drawer__empty"><strong>${escapeHtml(shell.dataset.emptyText)}</strong></div>`;
        footer.classList.add('is-hidden');
        return;
      }
      const items = cart.items.map((item) => {
        const image = item.featured_image?.url ? `<img src="${escapeHtml(item.featured_image.url)}&width=180" alt="${escapeHtml(item.featured_image.alt || item.product_title)}" width="180" height="180" loading="lazy">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__variant">${escapeHtml(item.variant_title)}</p>` : '';
        const properties = Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith('_')).map(([key, value]) => `<p class="cart-drawer__property">${escapeHtml(key)}: ${escapeHtml(value)}</p>`).join('');
        return `<article class="cart-drawer__item" data-cart-line data-key="${escapeHtml(item.key)}"><a class="cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a><div class="cart-drawer__item-info">${item.vendor ? `<p class="cart-drawer__vendor">${escapeHtml(item.vendor)}</p>` : ''}<a class="cart-drawer__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a><p class="cart-drawer__unit-price">${formatMoney(item.final_price, cart.currency)}</p>${variant}${properties}<div class="cart-drawer__controls"><div class="cart-drawer__quantity"><button type="button" data-cart-minus aria-label="${escapeHtml(shell.dataset.decreaseLabel)}">−</button><input type="number" value="${item.quantity}" min="0" data-cart-quantity aria-label="${escapeHtml(item.product_title)}"><button type="button" data-cart-plus aria-label="${escapeHtml(shell.dataset.increaseLabel)}">+</button></div><button class="cart-drawer__remove" type="button" data-cart-remove aria-label="${escapeHtml(shell.dataset.removeLabel)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-9 0 1 14h10l1-14M10 11v6m4-6v6"/></svg></button></div></div><strong class="cart-drawer__line-total">${formatMoney(item.final_line_price, cart.currency)}</strong></article>`;
      }).join('');
      body.innerHTML = `<div class="cart-drawer__labels"><span>${escapeHtml(shell.dataset.productLabel)}</span><span>${escapeHtml(shell.dataset.totalLabel)}</span></div><div class="cart-drawer__items" data-cart-items>${items}</div>`;
      footer.classList.remove('is-hidden');
      footer.querySelector('[data-cart-subtotal]').textContent = `${formatMoney(cart.total_price, cart.currency)} ${cart.currency}`;
      const note = footer.querySelector('[data-cart-note]');
      if (note && document.activeElement !== note) note.value = cart.note || '';
    };
    const getCart = async () => {
      const response = await fetch(`${shell.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    };
    const refresh = async () => render(await getCart());
    const change = async (key, quantity) => {
      drawer.classList.add('is-loading');
      try {
        const response = await fetch(`${shell.dataset.cartChangeUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        if (!response.ok) throw new Error('Unable to update cart');
        render(await response.json());
        status.textContent = 'Cart updated';
      } finally { drawer.classList.remove('is-loading'); }
    };
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) { event.preventDefault(); refresh().then(open).catch(console.error); return; }
      if (event.target.closest('[data-cart-close]')) { close(); return; }
      const line = event.target.closest('[data-cart-line]');
      if (!line) return;
      const input = line.querySelector('[data-cart-quantity]');
      if (event.target.closest('[data-cart-minus]')) change(line.dataset.key, Math.max(0, Number(input.value) - 1));
      if (event.target.closest('[data-cart-plus]')) change(line.dataset.key, Number(input.value) + 1);
      if (event.target.closest('[data-cart-remove]')) change(line.dataset.key, 0);
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-cart-quantity]')) change(event.target.closest('[data-cart-line]').dataset.key, Math.max(0, Number(event.target.value) || 0));
    });
    document.addEventListener('input', (event) => {
      if (!event.target.matches('[data-cart-note]')) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => fetch(`${shell.dataset.cartUpdateUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: event.target.value }) }), 500);
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
      event.preventDefault();
      const submitter = event.submitter;
      const originalText = submitter?.textContent;
      if (submitter) submitter.disabled = true;
      try {
        const response = await fetch(`${shell.dataset.cartAddUrl}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add product');
        await refresh();
        open();
      } catch (error) { console.error(error); }
      finally { if (submitter) { submitter.disabled = false; submitter.textContent = originalText; } }
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && shell.classList.contains('is-open')) close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
